/* Rug Branch — evens out flat rug photos in product cards.
   Supplier top views come with very different amounts of white space around the rug, so some rugs looked
   small and others filled the card. Each flat photo is measured once (a tiny canvas finds the rug's edges
   against the light background) and scaled so every rug fills its card the same way. */
(function () {
  const done = new WeakSet();
  const cache = {};
  function measure(img) {
    const key = (img.currentSrc || img.src || '').split('?')[0];
    if (cache[key]) return Promise.resolve(cache[key]);
    return new Promise((res) => {
      const probe = new Image(); probe.crossOrigin = 'anonymous';
      probe.onload = () => {
        try {
          const W = 72, H = Math.max(8, Math.round(72 * probe.naturalHeight / probe.naturalWidth));
          const c = document.createElement('canvas'); c.width = W; c.height = H;
          const x = c.getContext('2d', { willReadFrequently: true }); x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); x.drawImage(probe, 0, 0, W, H);
          const d = x.getImageData(0, 0, W, H).data;
          const bg = [d[0], d[1], d[2]];
          const far = (i) => Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]) > 36;
          let x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (let yy = 0; yy < H; yy++) for (let xx = 0; xx < W; xx++) if (far((yy * W + xx) * 4)) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
          if (x1 < 0) return res(null);
          const r = { w: (x1 - x0 + 1) / W, h: (y1 - y0 + 1) / H, cx: (x0 + x1 + 1) / 2 / W, cy: (y0 + y1 + 1) / 2 / H, ar: probe.naturalWidth / probe.naturalHeight };
          cache[key] = r; res(r);
        } catch (e) { res(null); }
      };
      probe.onerror = () => res(null);
      probe.src = img.currentSrc || img.src;
    });
  }
  async function fit(img) {
    if (done.has(img)) return; done.add(img);
    const r = await measure(img); if (!r) return;
    // how big the rug appears inside its card (photo is object-fit: contain inside the padded box)
    const cs = getComputedStyle(img), bw = img.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), bh = img.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    if (!(bw > 0 && bh > 0)) { done.delete(img); return; }
    const iw = r.ar >= bw / bh ? bw : bh * r.ar, ih = iw / r.ar; // displayed photo size
    const k = Math.min(1.8, (bw * 0.97) / (r.w * iw), (bh * 0.97) / (r.h * ih));
    if (k < 1.06) return;
    img.style.transformOrigin = `${(r.cx * 100).toFixed(1)}% ${(r.cy * 100).toFixed(1)}%`;
    img.style.setProperty('--rb-fit', k.toFixed(3));
    img.classList.add('rb-fit');
  }
  // measure each photo once it is loaded and actually visible (the flat view is often hidden until chosen)
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.target.naturalWidth && e.target.clientWidth) fit(e.target); }), { rootMargin: '200px' }) : null;
  function scan(root) {
    (root || document).querySelectorAll('.card-media img.is-flat, .room-media .rm-flat img').forEach((img) => {
      if (img.dataset.rbTrim) return; img.dataset.rbTrim = '1';
      if (io) io.observe(img);
      img.addEventListener('load', () => { if (io) { io.unobserve(img); io.observe(img); } else fit(img); });
    });
  }
  // switching between "In the room" and "The rug" changes which photo is visible: look again
  document.addEventListener('click', (e) => { if (e.target.closest('button, [data-view]')) setTimeout(() => document.querySelectorAll('img[data-rb-trim]').forEach((img) => { if (!done.has(img) && io) { io.unobserve(img); io.observe(img); } }), 400); });
  scan();
  new MutationObserver((ms) => { if (ms.some((m) => m.addedNodes.length)) scan(); }).observe(document.body, { childList: true, subtree: true });
})();
